export default function () {
  controller('slot-machine', self => {
    const machine = $(self);

    const settings = {
      duration: 1000,
      slowFactor: 10
    };

    machine.each(function() {
      const self = $(this);
      const $btn = self.find('.js-slot-btn');
      const $img = self.find('.js-slot-img');
      const $col = self.find('.js-slot-col');
      const $handle = self.find('.js-slot-handle');
      const $result = self.find('.js-slot-result');
      let flag = false;

      function cloneElem() {
        //clone first element for correct animation
        $img.each(function() {
          if ($(this).index() == 0) {
            $(this).clone().appendTo($(this).parent()).attr('data-number', 'cloned');
          }
        })
      }

      function stop(col, num) {
        const self = col;
        const img = self.find($img);
        const height = self.height();
        const number = num;
        let step = 0;
        let duration = 100;
        let iteration = 0;
        img.each(function() {
          if (number != 1) {
            if ($(this).data('number') == number) {
              step = -$(this).position().top;
            }
          } else {
            if ($(this).data('number') == 'cloned') {
              step = -$(this).position().top;
            }
          }
        });

        //slow stop animation
        anim();

        function anim() {
          //slow factor
          duration = duration + settings.slowFactor;
          self.css('top', 0);
          self.clearQueue().animate({
            top: -(height - 100)
          }, duration, 'linear', function() {
            iteration++;
            if (iteration < 5 + (self.data('col') * 2)) {
              anim();
            } else {
              animStop();
            }
          });
        }

        function animStop() {
          self.css('top', 0);
          self.clearQueue().animate({
            top: step
          }, duration, 'linear', function() {
            $handle.removeClass('active');
            setTimeout(function() {$result.show();}, 1000);
          });
        }
      }

      function start(result) {
        $col.each(function(index) {
          const self = $(this);
          const height = self.height();
          const step = -(height - 100);
          self.css('top', 0);

          self.animate({
            top: step
          }, 100, 'linear', function() {
            //flag toggle by setTimeout, duration set in settings
            if (!flag) {
              start(result);
            } else {
              //when flag is true, call stop animation function 
              stop(self, result[index]);
            }
          });
        })
      } 

      if ($img.length) {
        cloneElem();
        //click button "play"
        $btn.on('click', function() {
          if (!$handle.hasClass('active')) {
            //send ajax request for result
            $.ajax({
              url: 'slot.json',
              method: 'get'
            }).done(function(data) {

              flag = false;
              setTimeout(function() {
                flag = true;
              }, settings.duration);

              $handle.addClass('active');
              $result.hide();
              //start animation
              start(data.result);

            }).error(function(error) {
              console.log(error)
            })
          }
        });
      }
    });
  });
}